export default function Reaction4({
  size,
  color,
  className = "",
  onClick = () => {},
  active = false,
}) {
  return (
    <svg
      onClick={onClick}
      style={{
        cursor: "pointer",
        transition: "0.5s",
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        backgroundColor: active ? "#20419a" : "#ffffff",
        borderRadius: "50%",
      }}
      fill={active ? "#ffffff" : color}
      className={className}
      viewBox="0 0 64 64"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
    >
      <path
        stroke={active ? "#20419a" : color}
        strokeWidth="1"
        d="M32,3c16,0,29,13,29,29S48,61,32,61S3,48,3,32S16,3,32,3 M32,0C14.3,0,0,14.3,0,32s14.3,32,32,32
			s32-14.3,32-32S49.7,0,32,0L32,0z"
      />

      <path
        stroke={active ? "#20419a" : color}
        strokeWidth="1"
        d="M32,50.6c5,0,9.2-3.7,10-8.5c0.1-0.8-0.6-1.6-1.4-1.6H23.4c-0.8,0-1.5,0.7-1.4,1.6C22.8,46.9,27,50.6,32,50.6z"
      />
      <path
        stroke={active ? "#20419a" : color}
        strokeWidth="1"
        d="M24.4,23.4l1.7,3.1c0.4,0.7-0.2,1.5-1,1.4l-3.5-0.6L19,29.9c-0.6,0.6-1.5,0.3-1.6-0.5l-0.5-3.5l-3.2-1.6
	c-0.7-0.4-0.7-1.4,0-1.7l3.2-1.6l0.5-3.5c0.1-0.8,1.1-1.1,1.6-0.5l2.5,2.5l3.5-0.6c0.8-0.1,1.4,0.7,1,1.4L24.4,23.4z"
      />
      <path
        stroke={active ? "#20419a" : color}
        strokeWidth="1"
        d="M39.9,23.4l-1.7,3.1c-0.4,0.7,0.2,1.5,1,1.4l3.5-0.6l2.5,2.5c0.6,0.6,1.5,0.3,1.6-0.5l0.5-3.5l3.2-1.6
	c0.7-0.4,0.7-1.4,0-1.7L47.4,21l-0.5-3.5c-0.1-0.8-1.1-1.1-1.6-0.5l-2.5,2.5l-3.5-0.6c-0.8-0.1-1.4,0.7-1,1.4L39.9,23.4z"
      />
    </svg>
  );
}
